import { Flex } from "@mantine/core";

import AppStatus from "@/components/AppStatus";
import ColorSchemeSwitch from "@/components/ColorSchemeSwitch";
import LocaleSelectorGlobal from "@/components/Locale/LocaleSelectorGlobal";
import TermsMenu from "@/components/TermsMenu";

const LayoutFooter = () => {
  return (
    <Flex
      align="center"
      justify="center"
      wrap="wrap"
      gap="xs"
      px="xl"
      py="md"
      style={{ boxShadow: "var(--mantine-shadow-sm-inverted)" }}
    >
      <Flex gap={4} align="center" justify="space-around" wrap="nowrap">
        <ColorSchemeSwitch />
        <AppStatus />
        <LocaleSelectorGlobal />
        <TermsMenu />
      </Flex>
    </Flex>
  );
};

export default LayoutFooter;
